//import uagbTabs from './uagb-tabs';

export default {

    init() {
        this.scrollDir = 0;

        console.log('init-common');
        $('body').addClass('script-loaded');

        this.initMenuDesktop();
        this.initMenuFooter();
        this.initForm();

        // $('.selectpicker').selectpicker();
    },

    initMenuDesktop() {
        $('.main-header-menu .menu-item.menu-item-has-children').click((e) => {

            let $this = $(e.currentTarget);
            // let $parent = $this.parent('.footer-widget-area');
            if (window.matchMedia("(min-width: 544px)").matches) {
                $('body').toggleClass('main-submenu-open');
                $this.toggleClass('has-submenu-open');
            }
            e.stopPropagation();
        })
    },

    initMenuFooter () {
        $('.site-footer-section ul.menu .menu-item.menu-item-has-children > a').click((e) => {

            let $this = $(e.currentTarget);
            let $parent = $this.parent('.menu-item-has-children');

            if (window.matchMedia("(max-width: 599px)").matches) {
                $parent.toggleClass('has-submenu-open');
            }

            return false;
        })
    },

    initForm () {
        let selectPicker = $('.selectpicker');
        // console.log (selectPicker);

        selectPicker.each ( function () {
            // console.log (this);

            $(this).attr('title', $(this).find('option').eq(0).text());
            $(this).find('option').eq(0).remove();

            $('option', this).each( function () {
                $(this).attr('data-subtext', 'selected');
            })
        })

        selectPicker.on('show.bs.select', function (e, clickedIndex, isSelected, previousValue) {
            $('body').addClass('select-open');
        });

        selectPicker.on('hide.bs.select', function (e, clickedIndex, isSelected, previousValue) {
            $('body').removeClass('select-open');
        });

    },

    finalize() {
        console.log('finalize');
        var headerHeight = $('#ast-desktop-header').height();
        var lastScrollTop = 0;
        var delta = $('#ast-desktop-header').height();

        $(window).scroll ( (e) => {
            var nowScrollTop = $(e.currentTarget).scrollTop();
            if((Math.abs(lastScrollTop - nowScrollTop) >= delta) && (nowScrollTop > headerHeight)){
                if (nowScrollTop > lastScrollTop){
                    // ACTION ON
                    // SCROLLING DOWN
                    this.scrollDir = -1;
                    $('body').removeClass('body-scroll-up').removeClass('main-submenu-open').addClass('body-scroll-down');
                    $('.main-header-menu .menu-item.menu-item-has-children').removeClass('has-submenu-open');
                } else {
                    // ACTION ON
                    // SCROLLING UP
                    this.scrollDir = 1;
                    $('body').removeClass('body-scroll-down').addClass('body-scroll-up');
                }

                lastScrollTop = nowScrollTop;
            }

            if (nowScrollTop < delta) {
                $('body').removeClass('body-scroll-down body-scroll-up');
            }
        })

        $(document).click ((e) => {
            $('body').removeClass('main-submenu-open');
            $('.main-header-menu .menu-item.menu-item-has-children').removeClass('has-submenu-open');
        })

        let wpcf7Elm = document.querySelector( '.wpcf7' );

        wpcf7Elm.addEventListener( 'submit', function( event ) {
            let target = $('input[name="subject"]');

            $('html, body').animate( {
                scrollTop: $(target).offset().top
            }, 800);
        }, false );

        /* map
        let contactMap = $('.ootb-openstreetmap--map').get(0);
        console.log(L); */
    }
};
